WiseMetering.Views.RebuildIntegration = WiseMetering.Views.Modal.Custom.extend({
    buttons: ['ok', 'cancel'],
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/rebuild',
    title: () => i18next.t('modal.title.integrations.rebuild'),
    width: 800,

    ok: function() {
        this.block();

        this.model.rebuild({
            success: function() {
                WiseMetering.layout.showTipper('success', i18next.t('integrations.rebuild_scheduled'));
                this.close();
            }.bind(this),
            error: function(jqXHR) {
                const errorMessage = jqXHR.responseJSON?.error || i18next.t('ui.unspecified_error');
                WiseMetering.layout.showTipper('error', errorMessage);
                this.unblock();
            }.bind(this)
        });
    }
});
